import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fc99861"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderTab = _resolveComponent("OrderTab")!
  const _component_Ad = _resolveComponent("Ad")!
  const _component_SearchTargetingOrders = _resolveComponent("SearchTargetingOrders")!

  return (_openBlock(), _createBlock(_component_SearchTargetingOrders, {
    orders: _ctx.limitedOrders,
    isAllOrdersLoaded: _ctx.isAllOrdersLoaded,
    transitionSource: "SearchLimitedOrders",
    pageTitleWhenEmpty: "限定公開がありません",
    onFetchOrders: _cache[0] || (_cache[0] = () => _ctx.fetchLimitedOrders('append'))
  }, {
    orderTab: _withCtx(() => [
      _createVNode(_component_OrderTab, {
        orderType: 'limited',
        existsLimitedOrder: _ctx.limitedOrders.length > 0,
        existsIndividualOrder: _ctx.existsIndividualOfferOrders
      }, null, 8, ["existsLimitedOrder", "existsIndividualOrder"])
    ]),
    ad: _withCtx(() => [
      _createVNode(_component_Ad, {
        adSlot: "search_limited_order",
        class: "ad-slot-search"
      })
    ]),
    emptyDescription: _withCtx(() => [
      _createTextVNode("\n      勤務した事業所から評価されると "),
      _hoisted_1,
      _createTextVNode("\n      限定公開が配信されます "),
      _hoisted_2,
      _createTextVNode("\n      実績を重ねて限定公開を獲得しましょう！\n    ")
    ]),
    _: 1
  }, 8, ["orders", "isAllOrdersLoaded"]))
}